import { Injector, Component, ViewEncapsulation, Inject } from '@angular/core';

import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';

import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';
import {ImpersonationService} from '@app/admin/users/impersonation.service';
import {FieldAgentService} from '@app/webshop/field-agent/shared/services/field-agent.service';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';

@Component({
    templateUrl: './theme12-brand.component.html',
    selector: 'theme12-brand',
    encapsulation: ViewEncapsulation.None
})
export class Theme12BrandComponent extends AppComponentBase {

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;

    constructor(
        injector: Injector,
        private _fieldAgentOrderService: FieldAgentOrderService,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(injector);
    }

    clickTopbarToggle(): void {
        this.document.body.classList.toggle('m-topbar--on');
    }

    goHome() {
        event.preventDefault();

        if (this.isGuided) {
            this._fieldAgentOrderService.goHome();
        } else {
            window.location.href = '/';
        }
    }
}
